<template>
  <div>
    <div class="page-header page-header-small content-header">
      <div class="container">
        <h3 class="title">Datenschutzerklärung</h3>
        <!--
        <h5 class="description list">
          AutoEdge 24 - Inhaber: Andreas Leibolt<br>
          Grüsener Str. 17a<br>
          35285 Gemünden<br>
          Telefon: +49 176 55980480<br>
          E-Mail: kontakt@autoedge24.de<br>
          Internet: www.autoedge24.de
        </h5>
        -->
      </div>
    </div>
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">1. Verantwortlicher</h4>
            <h5 class="description list">
              AutoEdge 24 - Inh. Andreas Leibolt<br>
              Grüsener Str. 17a<br>
              35285 Gemünden<br>
              Telefon: +49 176 55980480<br>
              E-Mail: kontakt@autoedge24.de
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">2. Erhebung und Speicherung personenbezogener Daten</h4>
            <h5 class="description list">
              Wir verarbeiten personenbezogene Daten (Name, Anschrift, Telefonnummer, E-Mail-Adresse, Zahlungsinformationen) ausschließlich zur Erfüllung und Abwicklung Ihrer Bestellung sowie zur Erfüllung gesetzlicher Pflichten.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">3. Weitergabe von Daten</h4>
            <h5 class="description list">
              Eine Weitergabe an Dritte erfolgt nur, soweit dies zur Vertragserfüllung notwendig ist (z. B. Versanddienstleister, Zahlungsanbieter) oder gesetzliche Vorschriften dies verlangen.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">4. Speicherdauer</h4>
            <h5 class="description list">
              Personenbezogene Daten werden nur so lange gespeichert, wie dies zur Erfüllung des Vertrags oder gesetzlicher Aufbewahrungspflichten erforderlich ist.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">5. Ihre Rechte</h4>
            <h5 class="description list">
              Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit sowie Widerspruch gegen die Verarbeitung.<br>
              Zur Ausübung Ihrer Rechte können Sie uns jederzeit unter den angegebenen Kontaktdaten kontaktieren.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">6. Online-Streitbeilegung</h4>
            <h5 class="description list">
              Die EU-Kommission stellt eine Plattform zur Online-Streitbeilegung bereit: <a href="https://ec.europa.eu/consumers/odr">https://ec.europa.eu/consumers/odr</a>
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tabs, TabPane } from '@/components';

export default {
  name: 'privacy',
  bodyClass: 'privacy-page'
};
</script>
<style scoped>
.list {
  text-align: left;
  margin-left: 50px;
}
.page-header{
  background-color: white !important;
}
.page-header::before{
  background-color: white !important;
}
.description {
  font-weight: normal;
}

@media only screen and (max-width: 800px) {
  .list {
    margin-left: 10px;
  }
}
</style>
